export const CALENDLY_URL = "https://outlook.office.com/bookwithme/user/1c4234b13bde4820a75281e423f647af@gis-factory.com/meetingtype/mKK1SP3YhEqVidp3y8VO_A2?anonymous&ismsaljsauthenabled&ep=mLinkFromTile";

// Add other application constants here as needed 
